import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-125dbf42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scroll-area container-fluid" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { class: "mb-3 form-check form-switch form-check-reverse" }
const _hoisted_5 = {
  class: "form-check-label",
  for: "contactEmail"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "mb-3 form-check form-switch form-check-reverse" }
const _hoisted_8 = {
  class: "form-check-label",
  for: "contactPhone"
}
const _hoisted_9 = { class: "mt-5" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = { class: "mb-3 form-check form-switch form-check-reverse" }
const _hoisted_12 = {
  class: "form-check-label",
  for: "notifyMessage"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "mb-3 form-check form-switch form-check-reverse" }
const _hoisted_15 = {
  class: "form-check-label",
  for: "notifyPost"
}
const _hoisted_16 = { class: "mb-3 form-check form-switch form-check-reverse" }
const _hoisted_17 = {
  class: "form-check-label",
  for: "contactPhone"
}
const _hoisted_18 = { class: "mt-5" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_20 = ["id", "checked", "value"]
const _hoisted_21 = ["for"]
const _hoisted_22 = { class: "mt-5" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_24 = { class: "keywords" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "actions my-3" }
const _hoisted_27 = { class: "m-3" }
const _hoisted_28 = { class: "container p-3" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_30 = { class: "d-grid gap-2 mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadcrumbsBar = _resolveComponent("BreadcrumbsBar")!
  const _component_Field = _resolveComponent("Field")!
  const _component_PlusCircleOutline = _resolveComponent("PlusCircleOutline")!
  const _component_Form = _resolveComponent("Form")!
  const _component_vue_bottom_sheet = _resolveComponent("vue-bottom-sheet")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_BreadcrumbsBar, {
      back: "/me",
      backTitle: "",
      title: _ctx.t('mysettings')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.update,
        "validation-schema": _ctx.schema,
        class: "form-vertical form"
      }, {
        default: _withCtx(() => [
          _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t('mysettings')), 1),
          _createElementVNode("legend", null, _toDisplayString(_ctx.t('contactme')), 1),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              value: true,
              id: "contactEmail",
              name: "contactEmail",
              modelValue: _ctx.form.contactEmail,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.contactEmail) = $event)),
              change: _ctx.change
            }, null, 8, ["modelValue", "change"]),
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.t('phone')), 1),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              value: true,
              id: "contactPhone",
              name: "contactPhone",
              modelValue: _ctx.form.contactPhone,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.contactPhone) = $event)),
              onChange: _ctx.change
            }, null, 8, ["modelValue", "onChange"]),
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.t('email')), 1)
          ]),
          _createElementVNode("legend", _hoisted_9, _toDisplayString(_ctx.t('emailheading')), 1),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              value: true,
              id: "notifyMessage",
              name: "notifyMessage",
              modelValue: _ctx.form.notifyMessage,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.notifyMessage) = $event)),
              onChange: _ctx.change
            }, null, 8, ["modelValue", "onChange"]),
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t('newmessage')), 1),
            _hoisted_13
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              value: true,
              id: "contactPhone",
              name: "notifyPost",
              modelValue: _ctx.form.notifyPost,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.notifyPost) = $event)),
              onChange: _ctx.change
            }, null, 8, ["modelValue", "onChange"]),
            _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t('newpost')), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_Field, {
              class: "form-check-input",
              type: "checkbox",
              role: "switch",
              value: true,
              id: "notifyReply",
              name: "notifyReply",
              modelValue: _ctx.form.notifyReply,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.notifyReply) = $event)),
              onChange: _ctx.change
            }, null, 8, ["modelValue", "onChange"]),
            _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.t('postreply')), 1)
          ]),
          _createElementVNode("legend", _hoisted_18, _toDisplayString(_ctx.t('locale')), 1),
          _hoisted_19,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLocales, (loc, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "form-check form-check-inline",
              key: `loc${i}`
            }, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "radio",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.locale) = $event)),
                name: "locale",
                id: 'localeSelect' + i,
                checked: _ctx.locale == loc,
                value: loc,
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
              }, null, 40, _hoisted_20), [
                [_vModelRadio, _ctx.form.locale]
              ]),
              _createElementVNode("label", {
                class: "form-check-label",
                for: 'localeSelect' + i
              }, _toDisplayString(_ctx.t('locale_'+loc)), 9, _hoisted_21)
            ]))
          }), 128)),
          _createElementVNode("legend", _hoisted_22, _toDisplayString(_ctx.t('keywords')), 1),
          _hoisted_23,
          _createElementVNode("ul", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userStore.getters.keywords, (keyword) => {
              return (_openBlock(), _createElementBlock("li", {
                key: keyword,
                class: "keyword-wrap"
              }, [
                _createElementVNode("a", {
                  class: "btn btn-warning btn-rounded",
                  onClick: _withModifiers(($event: any) => (_ctx.removeKeyword(keyword)), ["prevent"])
                }, _toDisplayString(keyword) + " ×", 9, _hoisted_25)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              class: "btn btn-dark btn-rounded d-block mx-auto",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openInterestSheet && _ctx.openInterestSheet(...args)))
            }, [
              _createVNode(_component_PlusCircleOutline, { class: "pencil" }),
              _createTextVNode(_toDisplayString(_ctx.t('addkeyword')), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ]),
    _createVNode(_component_vue_bottom_sheet, { ref: "interestSheet" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("form", _hoisted_28, [
            _createElementVNode("legend", null, _toDisplayString(_ctx.t('addkeyword')), 1),
            _hoisted_29,
            _createVNode(_component_Field, {
              class: "form-control",
              type: "text",
              id: "interest",
              name: "keyword",
              modelValue: _ctx.form.keyword,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.keyword) = $event)),
              placeholder: _ctx.t('keyword')
            }, null, 8, ["modelValue", "placeholder"]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                name: "add",
                class: "btn btn-dark btn-lg",
                onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addKeyword && _ctx.addKeyword(...args)), ["prevent"]))
              }, _toDisplayString(_ctx.t('add')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}